import React from "react";
import { css } from "aphrodite";
import { styles } from "src/pages/AgreementPageStyles";
import { inject } from "mobx-react";
import { appStore } from "src/mobx/AppStore";
import { Application } from "src/core/application";

interface IAgreementPageProps {
    history: any
}

class AgreementPageState {
    public readonly isAgreed: boolean = false;
    public readonly error: string = "";
}

export class AggrementPage extends React.Component<IAgreementPageProps, AgreementPageState> {

    constructor(props: IAgreementPageProps){
        super(props);
        this.state = new AgreementPageState();
    }

    public render() {
        return (
            <div className={css(styles.content)}>
                <div className={css(styles.agreement)} >
                    I understand I am about to enter the UD Research Portal and the information contained in the portal is UD proprietary and may be confidential.
                    I agree not to disclose the data, raw or derived, with anyone inside or outside of UD without appropriate authorization and permission.
                </div>
                <div className={css(styles.checkbox_container)} >
                    <input type="checkbox" style={{width:"20px", height:"20px"}} id="cb_agreement" name="agreement" defaultChecked={this.state.isAgreed} onChange={this.onAgreementChange}/>
                    <label style={{marginLeft: "10px" }} htmlFor="cb_agreeement" > I have read the above statement and I agree to comply with the same </label>
                </div>
                <div id="continue" className={css(styles.button)} onClick={this.onContinueClick} >
                    Continue
                </div>
                <div id="error" style={{color: "red", textAlign: "center"}} >
                    {this.state.error}
                </div>                    
            </div>
        );
    }

    private onAgreementChange = (event: any) => {
        this.setState({...this.state, isAgreed: event.target.checked, error: ""})
    }

    private onContinueClick = (event: any) => {
        if(this.state.isAgreed){
            Application.setIsAgreed(true)
            this.props.history.push("/")
        }else{
            this.setState({...this.state, error: "You have to agree to the terms before continuing"})
        }
    }

}


// WEBPACK FOOTER //
// ./src/pages/AgreementPage.tsx